import React from 'react'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'



const Signin = () => {
    return (
        <>
        <Header signin={true}/>
        <Footer/>
        </>
    )
}

export default Signin
